/* eslint-disable */
import jsPDF from 'jspdf';
import signatureImage from '../../../assets/images/Signature.png';

let y = 80; // Starting y position
const lineHeight = 5; // Height for each line
const paragraphSpacing = 5; // Additional space between paragraphs
const leftMargin = 15; // Left margin for all text

function addFormattedText(doc, boldText, normalText, newParagraph = false, maxWidth = 155) {
    const boldWidth = doc.getTextWidth(boldText);

    // Add bold text
    doc.setFont('helvetica', 'bold');
    doc.text(boldText, leftMargin, y);

    // Prepare normal text
    doc.setFont('helvetica', 'normal');
    const splitText = doc.splitTextToSize(normalText, maxWidth);

    // Add first line of normal text after bold text
    doc.text(splitText[0], leftMargin + boldWidth + 5, y);

    // Add remaining lines of normal text
    for (let i = 1; i < splitText.length; i++) {
        y += lineHeight;
        doc.text(splitText[i], leftMargin, y);
    }

    // Move to next line
    y += lineHeight;

    // Add extra space if it's a new paragraph
    if (newParagraph) {
        y += paragraphSpacing;
    }
}

// Generate PDF
export const generatePdf = (companyName, address, phone, email, name) => {
    const doc = new jsPDF();

    // Set font size and style for title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');

    // Center the title
    const title = 'MLS Listings Agreement';
    const titleWidth = doc.getTextWidth(title);
    const pageWidth = doc.internal.pageSize.getWidth();
    const centerTitle = (pageWidth - titleWidth) / 2;
    const maxWidth = 80;

    // MLS Listings Agreement
    doc.text(title, centerTitle, 15);

    // Set font size and style for other text
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    // Display side-by-side cards
    doc.text('Listing Brokerage (“Provider”)', 15, 30);
    doc.line(15, 32, 65, 32);

    doc.text('Property Management Company (“Client”)', pageWidth / 2 + 5, 30);
    doc.line(pageWidth / 2 + 5, 32, pageWidth / 2 + 80, 32);

    // Provider Information (left side)
    doc.text('Brokerage Name: KX Realty PLLC', 15, 40);
    doc.text('Address: 1433 Lady Grey Ave, 78660', 15, 45);
    doc.text('Phone: 5123875314', 15, 50);
    doc.text('Email: khiere@kxrealtypllc.com', 15, 55);
    doc.text('License Number: #9007836', 15, 60);

    // Client Information (right side)
    doc.text(`Company Name: ${companyName || '-'}`, pageWidth / 2 + 5, 40);
    // Handle long address
    let addressLines = doc.splitTextToSize(`Address: ${address || '-'}`, maxWidth);
    doc.text(addressLines[0], pageWidth / 2 + 5, 45);
    let newY = 50;
    
    if (addressLines.length > 1) {
        for (let i = 1; i < addressLines.length; i++) {
            doc.text(addressLines[i], pageWidth / 2 + 5, newY);
            newY += lineHeight;
        }
    }

    doc.text(`Phone: ${phone || '-'}`, pageWidth / 2 + 5, newY);
    newY += lineHeight;
    doc.text(`Email: ${email || '-'}`, pageWidth / 2 + 5, newY);

    // Add Terms of Agreement text
    doc.text('Terms of Agreement:', 15, 70);
    doc.line(15, 72, 50, 72);

    addFormattedText(
        doc,
        'Authorization:',
        'The Client hereby grants the Provider exclusive authorization to create listings on the Multiple Listing Service (“MLS”) associated with the region in which the property or properties that are submitted by the Client are located. Provider will syndicate the listings to external websites unless Client requests otherwise.',
        true
    );

    addFormattedText(
        doc,
        'Listing Period:',
        'A listing will be active once the Provider posts the listing onto the MLS. A listing will terminate once the unit is rented or once the Client requests to terminate the listing.',
        true
    );

    addFormattedText(
        doc,
        'Listing Fee:',
        'In consideration for the services rendered, the Client agrees to pay a flat fee of $200.00 per listing per month the listing is active or $100.00 per listing if all available floor plans within the complex are listed. This fee is paid to the Provider within 30 days of the listing date. The Client will be invoiced on a monthly basis.',
        true
    );

    addFormattedText(
        doc,
        'Property Disclosure:',
        'The Client warrants that they will provide accurate and complete information about the property and disclose any known material defects. Both parties acknowledge that the Client is responsible for ensuring the legality of the units listed.',
        true,
        145
    );

    addFormattedText(
        doc,
        'Termination:',
        'Either party may terminate this agreement for just cause by written agreement with a 30 day notice. Upon termination, all obligations and liabilities under this agreement cease.',
        true
    );

    addFormattedText(
        doc,
        'Cooperating Brokerage:',
        'The Provider agrees to cooperate with other real estate brokerages and share the agreed-upon commission as specified by the Client and MLS rules.',
        true,
        135
    );

    addFormattedText(
        doc,
        'Marketing and Promotion:',
        'The Provider agrees to cooperate with other real estate brokerages and share the agreed-upon commission as specified by the Client and MLS rules.',
        true,
        135
    );

    addFormattedText(
        doc,
        'Price and Availability Changes:',
        'Any changes in the number of listings or their respective information must be submitted in writing or electronically by the Client to the Provider.',
        true,
        130
    );

    addFormattedText(
        doc,
        'Publicity:',
        `Each Party shall have the right to publicly announce the existence of the business relationship between the Parties. Provider may use Client’s name, trademarks, and logos (collectively, “Client’s Marks”) on Provider’s website and in its marketing materials to identify Client as Provider’s customer.`,
        true
    );

    addFormattedText(
        doc,
        'Agreement Acceptance:',
        'By signing below, the parties acknowledge their understanding and acceptance of the terms and conditions outlined in this Texas Listing Agreement.',
        true,
        135
    );

    // Add more text or content if needed
    // Handle pagination if content exceeds the page limit
    doc.addPage();

    // Add space for the signature
    doc.setFont('times', 'italic');
    doc.setFontSize(13);

    const today = new Date();

    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');
    const year = String(today.getFullYear()).slice(-2); // Get last 2 digits of the year

    const date = `${month}-${day}-${year}`;

    doc.text(`${name || '-'}`, 45, 50);
    doc.text(`${name || '-'}`, 64, 60);
    doc.text(date, 135, 60);

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    doc.text('Client Signature: ______________________________________', 15, 50);
    doc.text('Authorized Representative: __________________________ Date: ______________', 15, 60);

    // If the signature image is uploaded, add it to the PDF
    if (signatureImage) {
        const imgWidth = 50;
        const imgHeight = 20;
        doc.addImage(signatureImage, 'PNG', 60, 70, imgWidth, imgHeight);
    }

    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');

    doc.text('Provider Signature: __________________________________', 15, 90);
    doc.text('Authorized Representative: ____________________________', 15, 100);

    doc.setFont('times', 'italic');
    doc.setFontSize(13);
    doc.text('Khiere Simmons', 64, 100);

    // Download the PDF
    // doc.save('MLS_Agreement.pdf');
    window.open(doc.output('bloburl'), '_blank');

    return doc.output('blob');
};
